import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { post } from 'aws-amplify/api';
import '../styles/management.css';

function GuestImportScreen() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onload = (event) => {
        const text = event.target.result;
        const lines = text.split('\n');
        const headers = lines[0].split(',');
        const previewData = lines.slice(1, 6).map(line => {
          const values = line.split(',');
          return headers.reduce((obj, header, index) => {
            obj[header.trim()] = values[index]?.trim() || '';
            return obj;
          }, {});
        });
        setPreview(previewData);
      };
      reader.readAsText(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError('Please select a file first');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const reader = new FileReader();
      reader.onload = async (event) => {
        try {
          const restOperation = post({
            apiName: 'events',
            path: '/guests/import',
            options: {
              body: {
                event_id: eventId,
                csv_data: event.target.result
              }
            }
          });

          const response = await restOperation.response;
          const { body } = response;
          const result = await body.json();

          navigate(`/guests/${eventId}`, {
            state: { importResult: result }
          });
        } catch (err) {
          setError(err.message || 'Failed to import guests');
          setIsLoading(false);
        }
      };
      reader.readAsText(file);
    } catch (err) {
      setError('Error reading file');
      setIsLoading(false);
    }
  };

  return (
    <div className="page">
      <h2>Import Guests</h2>
      {error && <div className="error">{error}</div>}
      
      <form onSubmit={handleSubmit} className="form">
        <div className="form-group">
          <label htmlFor="file">Choose CSV File:</label>
          <input
            type="file"
            id="file"
            accept=".csv"
            onChange={handleFileChange}
            disabled={isLoading}
          />
        </div>

        {preview.length > 0 && (
          <div className="preview">
            <h3>Preview (first 5 rows)</h3>
            <table>
              <thead>
                <tr>
                  {Object.keys(preview[0]).map(header => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {preview.map((row, i) => (
                  <tr key={i}>
                    {Object.values(row).map((value, j) => (
                      <td key={j}>{value}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <button 
          type="submit" 
          disabled={!file || isLoading}
          className="button button--primary"
        >
          {isLoading ? 'Importing...' : 'Import Guests'}
        </button>
      </form>
    </div>
  );
}

export default GuestImportScreen;